<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Операции') }}</h1>
                    <span v-if="!isTransactionsLoaded">loading</span>
                </div>

                <div class="statement-list">
                    <StatementBlock :all="true" :show-btn="isFirstBlock(index)" :group="group" v-for="(group, index) in transactions" :key="index"/>
                </div>
            </div>

            <div class="right-side-container sticky">
                <RightSideUserControls />

                <StatementFilters :class="{'show-mobile-filters': showFilters}" />

                <button class="btn show-filters-btn mobile" @click="showFilters = !showFilters">
                    <span>{{ showFilters ? $t('Скрыть фильтры') : $t('Открыть фильтры') }}</span>
                </button>
            </div>
        </div>

        <MobilePlusBtn type="new-transaction" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import StatementBlock from "@/new/components/Statement/StatementBlock.vue";
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";
import StatementFilters from "@/new/components/Statement/StatementFilters.vue";
import { EventBus } from '../../../event-bus';

export default {
    name: "Statement",

    components: {
        RightSideUserControls,
        StatementBlock,
        MobilePlusBtn,
        StatementFilters
    },

    data: function() {
        return {
            showFilters: false,
        };
    },

    mounted() {
        this.loadCategories();
        this.loadAccounts();

        this.loadWithFilters();
    },

    computed: {
        ...mapGetters(['categories', 'transactions', 'accounts', 'isTransactionsLoaded']),
    },
    
    methods: {
        ...mapActions(['loadCategories', 'loadTransactions', 'loadAccounts']),

        loadWithFilters() {
            this.loadTransactions({filters: {}});
        },

        isFirstBlock(index) {
            return Object.keys(this.transactions).indexOf(index) === 0;
        }
    }
}
</script>

<style scoped lang="scss">
.statement-list {
    @media (max-width: 768px) {
        padding-top: 24px;
    }
}

.show-mobile-filters {
    @media (max-width: 768px) {
        display: block;
    }
}

.show-filters-btn {
    padding: 15px;
    background: #152640;
    border: none;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: calc(100% - 30px);
    text-align: center;
    justify-content: center;
    margin: 15px;

    @media (min-width: 768px) {
        display: none;
    }

    span {
        font-family: 'Proxima Nova Lt';
        font-weight: 600;
        font-size: 12px;
    }
}
</style>